import { Routes, Route, Navigate } from 'react-router-dom';
import WhatsAppInbox from './pages/WhatsAppInbox';
import WhatsAppSettings from './pages/WhatsAppSettings';

// Mounted at /whatsapp/* in App.js. The inbox is the default; settings is the
// admin config panel (also linked from Settings in the sidebar). Access is
// enforced server-side (config routes require an admin).
const WhatsAppRoutes = () => (
  <Routes>
    <Route path="/" element={<WhatsAppInbox />} />
    <Route path="inbox" element={<WhatsAppInbox />} />
    <Route path="settings" element={<WhatsAppSettings />} />
    <Route path="*" element={<Navigate to="/whatsapp" replace />} />
  </Routes>
);

export default WhatsAppRoutes;
